import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackStop.svg",
  "use": "PlaybackStop.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackStop.svg\"><path d=\"M47.01,14.0208a3,3,0,0,1,3,3v30a3,3,0,0,1-3,3h-30a3,3,0,0,1-3-3v-30a3,3,0,0,1,3-3Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol